import { useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';

import { RibbonButton, RibbonSection } from 'common/components';

import { Can } from 'context/Can';
import { ADVANCED_FILTER_MODE } from 'pages/reporting/utils/constans';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const ExportMergedReporting = (props) => {
  const { modeData, onClickRibbonBtn, disabledConsolidated } = props;
  const [loading, setLoading] = useState();

  const onClickExportBtn = () => {
    setLoading(true);
    onClickRibbonBtn('mergedExport', setLoading);
  };

  const disabled =
    modeData === ADVANCED_FILTER_MODE.FLAT_DATA || disabledConsolidated;

  return (
    <RibbonSection>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <RibbonButton
          loading={loading}
          icon={<DownloadOutlined />}
          label='Consolidated Report'
          onClick={onClickExportBtn}
          disabled={disabled || loading}
        />
      </Can>
    </RibbonSection>
  );
};

export default ExportMergedReporting;
